import { WellnessScoreStatus } from "../../../Common/types";

/** Ranges: >9 hours green (Healthy), 7–9 hours amber (NeedsAttention), <7 hours red (NeedsSupport). */
export function getSleepStatus(hoursPerNight: number): WellnessScoreStatus {
  if (hoursPerNight > 9) return WellnessScoreStatus.Healthy;
  if (hoursPerNight >= 7) return WellnessScoreStatus.NeedsAttention;
  return WellnessScoreStatus.NeedsSupport;
}

/** Returns display label for the sleep band (e.g. ">9", "7-9", "<7"). */
export function getSleepDisplayValue(hoursPerNight: number): string {
  if (hoursPerNight > 9) return ">9";
  if (hoursPerNight >= 7) return "7-9";
  return "<7";
}
